<script lang="ts" setup>
import { globalCssVariables } from 'monocle-components/internal'
import { useDarkMode } from '~/composables/useDarkMode'

void globalCssVariables
useDarkMode()
</script>

<template>
  <div class="viewer-layout">
    <slot />
  </div>
</template>

<style scoped>
.viewer-layout {
  background-color: var(--background-color);
  color: var(--text-color);
  min-height: 100dvh;
}
</style>
